export default __webpack_public_path__ + "static/media/Glitch2.4ecacf51.mp3";